import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Chip } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

const ContactsTableRow = ({
    contact,
    index,
    selectedIds,
    onRowCheckboxClick,
    onMenuOpen,
    perms,
}) => {
    const { i18n } = useTranslation();
    const lng = i18n.language || 'en';
    const isArabic = lng.startsWith('ar');
    const isSelected = selectedIds.includes(contact.id);

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onClick={(event) => onRowCheckboxClick(event, contact.id)}
                />
            </TableCell>
            <TableCell>{index + 1}</TableCell>
            <TableCell>{contact.name || contact.full_name || '-'}</TableCell>
            <TableCell>{contact.email || '-'}</TableCell>
            <TableCell>{contact.subject || '-'}</TableCell>
            <TableCell align="center">
                <Chip
                    label={contact.is_read ? (isArabic ? 'مقروء' : 'Read') : (isArabic ? 'غير مقروء' : 'Unread')}
                    size="small"
                    color={contact.is_read ? 'success' : 'warning'}
                    variant="outlined"
                />
            </TableCell>
            <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                {contact.created_at ? dayjs(contact.created_at).format('YYYY-MM-DD') : '-'}
            </TableCell>
            <TableCell align="right">
                <IconButton onClick={(event) => onMenuOpen(event, contact)}>
                    <MoreVertIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default ContactsTableRow;
